import DealTaxesInfo from './DealTaxesInfo';

export { DealTaxesInfo };
